const numberMask = (min = 0, max, padFractionalZeros = true) => {
  return {
    mask: 'num',
    overwrite: true,
    blocks: {
      num: {
        mask: Number,
        scale: 2,
        padFractionalZeros,
        inputMode: 'decimal',
        normalizeZeros: false,
        thousandsSeparator: '',
        radix: '.',
        mapToRadix: [','],
        min,
        max
      }
    }
  }
}

export default numberMask
